module.exports = __webpack_public_path__ + "files/SPIADI2021 - Rapport National provisoire - juin 2022.fe828ee5e07d45d6137d17245a1307f6.pdf";